export const SERVICES = [
  {
    label: 'Live Event Printing',
    to: '/live-events',
    terms: ['merch printing', 'screen print', 'live print', 'on-site', 'customiz', 'heat press', 'embroider', 'apparel'],
  },
  {
    label: 'Merch Booths',
    to: '/live-events',
    terms: ['booth', 'swag', 'trade show', 'conference', 'festival', 'retail', 'corporate'],
  },
  {
    label: 'Artist Merch',
    to: '/artist-merch',
    terms: ['brand identity', 'branding', 'artist', 'creative', 'design', 'strategy', 'identity'],
  },
  {
    label: 'Full Production',
    to: '/production',
    terms: ['plan', 'step-by-step', 'setup', 'production', 'sourcing', 'fulfillment', 'operations', 'logistics'],
  },
];

const STOP = new Set(['with', 'your', 'that', 'this', 'from', 'what', 'into', 'guide', 'complete', 'brands', 'events', 'event']);

const topicText = (p) => [p.title, p.category, ...(p.keywords || [])].join(' ').toLowerCase();

const tokens = (p) => new Set(topicText(p).split(/[^a-z0-9]+/).filter((w) => w.length > 3 && !STOP.has(w)));

const hits = (text, terms) => terms.reduce((n, t) => n + text.split(t).length - 1, 0);

// Category matches weigh 3, keywords 2, title 1.
export function serviceFor(post) {
  const cat = (post.category || '').toLowerCase();
  const kw = (post.keywords || []).join(' | ').toLowerCase();
  const title = (post.title || '').toLowerCase();
  let best = SERVICES[0];
  let bestScore = 0;
  SERVICES.forEach((s) => {
    const score = hits(cat, s.terms) * 3 + hits(kw, s.terms) * 2 + hits(title, s.terms);
    if (score > bestScore) { best = s; bestScore = score; }
  });
  return best;
}

function relevance(a, b) {
  const kwA = new Set((a.keywords || []).map((k) => k.toLowerCase()));
  const sharedKw = (b.keywords || []).filter((k) => kwA.has(k.toLowerCase())).length;
  const tA = tokens(a);
  const sharedTokens = [...tokens(b)].filter((w) => tA.has(w)).length;
  const sameCategory = a.category && a.category === b.category ? 3 : 0;
  return sameCategory + sharedKw * 2 + sharedTokens;
}

// Hand-picked posts first (in chosen order), then the best topic matches.
export function getRelatedPosts(post, all, limit = 4) {
  const others = all.filter((p) => p.slug !== post.slug);
  const picked = (post.relatedSlugs || [])
    .map((s) => others.find((p) => p.slug === s))
    .filter(Boolean);
  const auto = others
    .filter((p) => !picked.includes(p))
    .map((p) => ({ p, score: relevance(post, p) }))
    .sort((x, y) => y.score - x.score || String(y.p.publishedAt).localeCompare(String(x.p.publishedAt)))
    .map((x) => x.p);
  return [...picked, ...auto].slice(0, limit);
}
